var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationalInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1409_23546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6481 4.51162L9.17546 1.52225C9.06194 1.48217 8.93809 1.48217 8.82457 1.52225L0.351914 4.51162C0.141258 4.58594 0.000281671 4.78492 4.21419e-07 5.0083C-0.000280829 5.23169 0.140239 5.43099 0.350719 5.5058L8.82338 8.51788C8.8805 8.5382 8.94027 8.54836 9 8.54836C9.05977 8.54836 9.1195 8.5382 9.17662 8.51788L17.6493 5.5058C17.8598 5.43099 18.0002 5.23169 18 5.0083C17.9997 4.78492 17.8587 4.58594 17.6481 4.51162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7349 11.551V6.95117L15.6802 7.32611V11.551C15.3625 11.7339 15.1484 12.0765 15.1484 12.4693C15.1484 12.8622 15.3625 13.2048 15.6802 13.3876V15.9792C15.6802 16.2705 15.9163 16.5066 16.2075 16.5066C16.4988 16.5066 16.7349 16.2705 16.7349 15.9792V13.3877C17.0525 13.2049 17.2666 12.8622 17.2666 12.4694C17.2666 12.0765 17.0526 11.7339 16.7349 11.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 9.60307C8.819 9.60307 8.64072 9.5723 8.47011 9.51166L3.70703 7.81836V10.139C3.70703 10.7067 4.29931 11.1868 5.46741 11.5659C6.48557 11.8964 7.74016 12.0784 9.00002 12.0784C10.2599 12.0784 11.5144 11.8964 12.5326 11.5659C13.7007 11.1868 14.293 10.7067 14.293 10.139V7.81836L9.52996 9.51166C9.35931 9.5723 9.18104 9.60307 9.00002 9.60307Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_23546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationalInfoIcon);
export default __webpack_public_path__ + "static/media/educational-info-icon.5df30a9e1185d6ff7dbbbfdefa8be99f.svg";
export { ForwardRef as ReactComponent };